module.exports = __webpack_public_path__ + "img/Beijing-power.9f2d705b.png";